import { useNavigate, Link } from "react-router-dom";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import "./Scan.css";
import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const ServiceArea = () => {
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState(new Set()); // For pin code table
  const [selectedFranchise, setSelectedFranchise] = useState(null); // For franchise details
  const [MappedServiceareas, setMappedServiceareas] = useState(null);

  const axiosPrivate = useAxiosPrivate();
  const FRANCHISES_URL = "api/list-franchises";
  const [franchiseDetails, setFranchises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const LIST_MAPPED_SERVICEAREAS_URL = "/api/list-mapped-serviceareas?";
  const LIST_UN_MAPPED_SERVICEAREAS_URL = "/api/list-un-mapped-serviceareas";
  const UPDATE_SERVICEAREAS_URL = "/api/update-serviceareas";
  const DELETE_PINCODE_URL = "/api/delete-servicearea";
  const [message, setMessage] = useState("");

  // Modal control state
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);


  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const handleDeleteShowModal = () => setShowDeleteModal(true);
  const handleDeleteCloseModal = () => setShowDeleteModal(false);
  const [selectedServiceArea, setSelectedServiceArea] = useState(null);

  const handleDeleteShowModal = (serviceArea) => {
    setSelectedServiceArea(serviceArea);
    setShowDeleteModal(true);
  };




  const [pincode, setPincode] = useState("");
  const [results, setResults] = useState([]);

  const [serviceOptions, setServiceOptions] = useState({});


  useEffect(() => {
    if (!selectedFranchise) return;

    if (pincode.length >= 3) {
      const fetchData = async () => {
        const params = {
          franchise_id: selectedFranchise.franchise_id,
          pincode: pincode
        };
        try {
          const response = await axiosPrivate.get(LIST_UN_MAPPED_SERVICEAREAS_URL, {
            withCredentials: true,
            params,
          });
          setResults(response.data); // Save response to state

        } catch (error) {
          console.error("API error:", error);
        }
      };
      fetchData();
    }
  }, [pincode, selectedFranchise]);




  const handleDeletePincode = async (pincodeId) => {
    console.log("franchiseDetails")
    console.log("franchiseDetails", selectedFranchise.franchise_id)
    try {
      const response = await axiosPrivate.delete(DELETE_PINCODE_URL, {
        params: {
          pincode_id: pincodeId,
          franchise_id: selectedFranchise.franchise_id
        },
        withCredentials: true, // Include cookies if needed
      });

      if (response.status === 200) {
        await fetchMappedServiceAreas(selectedFranchise.franchise_id);
        // alert("Deleted successfully!");
        // Optionally, refresh the pincode list here
      }
    } catch (error) {
      console.error("Error deleting pincode:", error);
      alert("Failed to delete pincode.");
    }
    handleDeleteCloseModal();
  };



  const handleSaveSelectedPincodes = async () => {
    const selectedData = [];

    results.forEach(item => {
      if (selectedRows.has(item.pincode_id)) {
        selectedData.push({
          pincode_id: item.pincode_id,
          collection: serviceOptions[item.pincode_id]?.collection ? "true" : "false",
          delivery: serviceOptions[item.pincode_id]?.delivery ? "true" : "false",
          on_demand: serviceOptions[item.pincode_id]?.on_demand ? "true" : "false"
        });
      }
    });

    const payload = {
      franchise_id: selectedFranchise.franchise_id,
      pincodes: selectedData
    };

    // Helper to convert boolean to "true"/"false" strings
    const boolToString = (val) => (val ? "true" : "false");

    let mergedPayload = { ...payload };

    if (MappedServiceareas && MappedServiceareas.length > 0) {
      const newPincodes = MappedServiceareas.map(area => ({
        pincode_id: area.pincode_id,
        collection: boolToString(area.collection),
        delivery: boolToString(area.delivery),
        on_demand: boolToString(area.on_demand)
      }));

      mergedPayload.pincodes = [...payload.pincodes, ...newPincodes];
    }

    console.log(mergedPayload);

    try {
      const response = await axiosPrivate.post(UPDATE_SERVICEAREAS_URL, mergedPayload);
      setMessage(response.data.message); // Set the success message
      await fetchMappedServiceAreas(selectedFranchise.franchise_id);
    } catch (error) {
      console.error("Error saving selected pincodes:", error);
      // Optional: display a user-friendly error message
    }

    handleCloseModal();
  };




  const fetchMappedServiceAreas = useCallback(async (id) => {
    setLoading(true);
    const params = {
      franchise_id: id,
    };

    try {
      const response = await axiosPrivate.get(LIST_MAPPED_SERVICEAREAS_URL, {
        withCredentials: true,
        params,
      });
      setMappedServiceareas(response.data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching service areas:", error);
      setError(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to load service areas"
      );
      setLoading(false);
    }
  }, [axiosPrivate]);



  const fetchFranchises = useCallback(async () => {
    try {
      const response = await axiosPrivate.get(FRANCHISES_URL, {
        withCredentials: true,
      });
      setFranchises(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Franchise:", error);
      setError(error?.response?.data?.message || "Failed to load franchises");
      setLoading(false);
    }
  }, [axiosPrivate]);



  useEffect(() => {
    fetchFranchises();
  }, [fetchFranchises]);

  const data = [
    { id: 1, column1: "Data 1", column2: "Data 2", column3: "Data 3" },
    { id: 2, column1: "Data 4", column2: "Data 5", column3: "Data 6" },
    { id: 3, column1: "Data 7", column2: "Data 8", column3: "Data 9" },
  ];




  // const handleSelectFranchise = async (id) => {
  //   setLoading(true);
  //   setSelectedFranchise(franchiseDetails[id - 1]);

  //   try {
  //     await fetchMappedServiceAreas(id); // Assuming this returns a Promise
  //   } catch (error) {
  //     console.error("Error fetching service areas:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSelectFranchise = async (id) => {
    setLoading(true);

    const selected = franchiseDetails.find(
      (franchise) => franchise.franchise_id === id
    );

    setSelectedFranchise(selected);

    try {
      await fetchMappedServiceAreas(id);
    } catch (error) {
      console.error("Error fetching service areas:", error);
    } finally {
      setLoading(false);
    }
  };



  const toggleRowSelection = (pincodeId) => {
    const newSelectedRows = new Set(selectedRows);
    if (newSelectedRows.has(pincodeId)) {
      newSelectedRows.delete(pincodeId);
    } else {
      newSelectedRows.add(pincodeId);
    }
    setSelectedRows(newSelectedRows);
  };


  const toggleSelectAll = () => {
    setSelectedRows(
      selectedRows.size === results.length
        ? new Set()
        : new Set(results.map((item) => item.pincode_id))
    );
  };




  const handleServiceToggle = (id, key) => {
    setServiceOptions((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [key]: !prev[id]?.[key],
      },
    }));
  };


  return (
    <>
      <section className="servicenewbody">
        <div className="wrapper10">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          <h3>Service Area</h3>
          {loading && <p>Loading...</p>}

          <Row>
            <Col md={5}>
              <div className="table-responsive">
                <table border="1" id="customers">
                  <thead>
                    <tr>
                      {/* <th>ID</th> */}
                      <th>Franchise</th>
                      <th>Service Area</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading && <p>Loading...</p>}

                    {franchiseDetails.length === 0 ? (
                      <tr>
                        <td colSpan="6">No franchises available.</td>
                      </tr>
                    ) : (
                      franchiseDetails.map((franchise) => (
                        <tr
                          key={franchise.franchise_id}
                          onClick={() => handleSelectFranchise(franchise.franchise_id)}
                          style={{ cursor: "pointer" }}
                        >
                          {/* <td>{`${franchise.franchise_id}`}</td> */}
                          <td>{`${franchise.franchise_name} - ${franchise.franchise_code}`}</td>
                          <td>{franchise.service_areas}</td>
                        </tr>

                      ))
                    )}
                  </tbody>




                </table>
              </div>
            </Col>
            <Col md={7}>
              <div className="table-responsive">
                <table border="1" id="customers">
                  <thead>
                    <tr>
                      <th>Franchise</th>
                      {/* <th>Franchise Id</th> */}
                      <th>Business Type</th>
                      <th>Contact Person</th>
                      <th>Mobile </th>
                      <th>Service Areas</th>

                    </tr>
                  </thead>
                  <tbody>
                    {selectedFranchise ? (
                      <tr>
                        <td>{selectedFranchise.franchise_name} - {selectedFranchise.franchise_code}</td>
                        {/* <td>{selectedFranchise.franchise_id}</td> */}
                        <td>{selectedFranchise.business_type}</td>
                        <td>{selectedFranchise.contact_person}</td>
                        <td>{selectedFranchise.mobile}</td>
                        <td>{selectedFranchise.service_areas}</td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan="6">No franchise selected</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* {selectedFranchise && selectedFranchise.name?.trim() !== "" && ( */}
                {selectedFranchise && selectedFranchise.franchise_name?.trim() !== "" && (

                  <button onClick={handleShowModal} type="button" className="btn btn-warning ms-auto d-block top-bt">ADD PINCODE</button>
                )}

                <table border="1" id="customers">
                  <thead>
                    <tr>

                      {/* <th>Picode id</th> */}
                      <th>Pincode</th>
                      <th> District & Post Office</th>
                      <th>Collection</th>
                      <th>Delivery</th>
                      <th>On demand</th>
                      <th>Options</th>
                    </tr>
                  </thead>


                  <tbody>
                    {!MappedServiceareas || MappedServiceareas.length === 0 ? (
                      <tr>
                        <td colSpan="7">No service areas available.</td>
                      </tr>
                    ) : (
                      MappedServiceareas.map((M_Serviceareas) => (
                        <tr key={M_Serviceareas.pincode_id}>
                          {/* <td>{M_Serviceareas.pincode_id}</td> */}
                          <td>{M_Serviceareas.pincode}</td>
                          <td>{M_Serviceareas.district} - {M_Serviceareas.post_office}</td>
                          <td>{M_Serviceareas.collection ? "True" : "False"}</td>
                          <td>{M_Serviceareas.delivery ? "True" : "False"}</td>
                          <td>{M_Serviceareas.on_demand ? "True" : "False"}</td>
                          {/* <button type="button" class="btn btn-danger"
          onClick={() => handleDeletePincode(M_Serviceareas.pincode_id)}
      >DELETE</button> */}
                          <button type="button" class="btn btn-danger"
                            onClick={() => handleDeleteShowModal(M_Serviceareas)}
                          >Dlt</button>

                        </tr>
                      ))
                    )}

                  </tbody>
                </table>

              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Modal Component */}
      <Modal show={showModal} onHide={handleCloseModal} className="popmodal" >
        <Modal.Header closeButton>
          <Modal.Title>Add Pincode</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input type="text" placeholder="Enter Pincode" className="form-control" /> */}
          <Row>
            <Col></Col>
            <Col>
              <input
                type="text"
                placeholder="Enter Pincode"
                className="form-control"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
              />
            </Col>
            <Col></Col>
          </Row>

          <table border="1" id="customers">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={toggleSelectAll}
                    checked={selectedRows.size === results.length && results.length > 0}

                  />
                </th>
                <th>Pincode</th>
                <th>Post Office</th>
                <th>District</th>
                <th>Collection</th>
                <th>Delivery</th>
                <th>On Demand</th>
                {/* <th>ID</th> */}
              </tr>
            </thead>
            {results.length > 0 && (
              <tbody>
                {results.map((item) => (
                  <tr key={item.pincode_id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.has(item.pincode_id)}
                        onChange={() => toggleRowSelection(item.pincode_id)}
                      />
                    </td>
                    <td>{item.pincode}</td>
                    <td>{item.post_office}</td>
                    <td>{item.district}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={serviceOptions[item.pincode_id]?.collection || false}
                        onChange={() => handleServiceToggle(item.pincode_id, 'collection')}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={serviceOptions[item.pincode_id]?.delivery || false}
                        onChange={() => handleServiceToggle(item.pincode_id, 'delivery')}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={serviceOptions[item.pincode_id]?.on_demand || false}
                        onChange={() => handleServiceToggle(item.pincode_id, 'on_demand')}
                      />
                    </td>
                    {/* <td>{item.pincode_id}</td> */}
                  </tr>
                ))}
              </tbody>
            )}
          </table>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveSelectedPincodes}>
            Save
          </Button>


          {/* <Button variant="primary" onClick={() => {
  // Create an array to store selected data
  const selectedData = [];

  results.forEach(item => {
    if (selectedRows.has(item.pincode_id)) {
      selectedData.push({
        pincode_id: item.pincode_id,
        collection: serviceOptions[item.pincode_id]?.collection || false,
        delivery: serviceOptions[item.pincode_id]?.delivery || false,
        on_demand: serviceOptions[item.pincode_id]?.on_demand || false
      });
    }
  });

  console.log("Selected Data:", selectedData);

  handleCloseModal();
}}>
  Save
</Button> */}

        </Modal.Footer>
      </Modal>







      <Modal show={showDeleteModal} onHide={handleDeleteCloseModal} className="popmodal">
        <Modal.Header closeButton>
          <Modal.Title>Remove Pincode</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove Post Office: <strong>{selectedServiceArea?.post_office}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleDeletePincode(selectedServiceArea?.pincode_id)}
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>



    </>
  );
};

export default ServiceArea;